<template>
	<div>
		<v-card class="sidebar">
			<v-list class="sidebar-list">

				<v-list-item
					v-for="link in prettyAppBaseMenu"
					:key="link.id"
					class="sidebar-list__item"
				>
					<v-list-item-content class="sidebar-list__content">
						<router-link
							active-class="active"
							:to="link.route"
							exact
							class="text-decoration-none"
						>
							<v-list-item-title class="sidebar-list__title text-wrap">{{
								link.title
							}}</v-list-item-title>
						</router-link>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					v-for="webViewlink in prettyAppWebViewMenu"
					:key="webViewlink.id"
					class="sidebar-list__item"
				>
					<v-list-item-content class="sidebar-list__content">
						<a
							:href="webViewlink.route"
							target="_blank"
							class="text-decoration-none"
						>
							<v-list-item-title class="sidebar-list__title text-wrap">{{
									webViewlink.title
								}}</v-list-item-title>
						</a>
					</v-list-item-content>
				</v-list-item>

			</v-list>
		</v-card>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import plusIcon from '@/assets/images/icon-plus.svg'
import { uuid } from 'vue-uuid'

export default {
	name: 'AppSidebar',
	watch: {
		selectedTags: {
			handler(val) {
				this.$eventBus.$emit('selected-tags', val)
			},
		},
	},
	props: {
		menuListHandler: {
			type: Function,
			default: () => {},
		},
	},
	data() {
		return {
			plusIcon: plusIcon,
		}
	},
	computed: {
		...mapGetters('user', ['popularAuthors', 'isPopularAuthorsLoading']),
		...mapGetters('settings', ['appCore']),

		prettyAppBaseMenu() {
			if (!this.appCore) {
				return [];
			}
			return this.appCore.appMenuNormalized.baseMenuItems;
		},
		prettyAppWebViewMenu() {
			if (!this.appCore) {
				return []
			}
			return this.appCore.appMenuNormalized.webViewMenuItems;
		}
	},
	methods: {
		...mapActions('user', ['fetchPopularAuthors'])
	},
}
</script>

<style lang="scss">
.active {
	text-decoration: none;
	> div {
		color: #4a4a4a !important;
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		line-height: 20px;
	}
}
.sidebar {
	margin-top: 28px;
	max-width: 250px;
	width: 100%;
	border-radius: 10px !important;
	box-shadow: none !important;
}
.sidebar-list {
	padding: 26px 30px 6px 30px;

	&__item {
		font-size: 10px !important;
		font-family: Montserrat, sans-serif;
		font-weight: 500;
		line-height: 20px;
		color: #41a1d8 !important;
		padding: 0;
		min-height: 38px;
	}
	&__content {
		padding: 0 0 20px 0;
	}
	&__title {
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: 500;
		line-height: 20px;
		color: #41a1d8 !important;
	}
}
.create-post {
	&__submit {
		width: 250px;
		height: 54px;
		margin-top: 30px;
		background: rgb(65, 161, 216) !important;
		border-radius: 10px;
		text-transform: capitalize !important;
		color: rgb(255, 255, 255) !important;
		font-size: 16px !important;
		font-family: Montserrat, sans-serif !important;
		font-weight: bold;
		align-items: center;
	}
}
</style>
